<div *ngFor="let item of dataView; trackBy: trackByFn" [ngClass]="['level-' + item['level']]">
    <span class="key">{{ item.key }}</span>
    <span class="value">{{ item.val }}</span>
</div>
